import React, { useContext, useState, useEffect } from 'react';
import { Input, Tooltip } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { DevicesTabContext, IDevicesTabContext } from '../../../devicesTabState/devicesTabContext';
import style from './SearchField.module.scss';

const SearchField: React.FC = () => {
	const { changeDevicesTabSearchString, devicesTabSearchString } = useContext<IDevicesTabContext>(DevicesTabContext);
	const [value, setValue] = useState<string>('');
	const { t } = useTranslation('global');

	useEffect(() => {
		const timeoutID = setTimeout(() => {
			changeDevicesTabSearchString(value);
		}, 800);
		return () => {
			return clearTimeout(timeoutID);
		};
	}, [value]);

	useEffect(() => {
		if (devicesTabSearchString !== value) {
			setValue(devicesTabSearchString);
		}
	}, [devicesTabSearchString]);

	return (
		<Input
			className={style.searchInput}
			onChange={(e) => setValue(e.target.value)}
			value={value}
			placeholder={t('searchPlaceholder')}
			allowClear={true}
			suffix={
				<Tooltip title={t('searchPlaceholder')}>
					<SearchOutlined className={style.searchIcon} />
				</Tooltip>
			}
		/>
	);
};

export default SearchField;
